import React from 'react';
import { Text, Flex, Stack } from '@tapresearch/ui/components';
import { Square } from '@chakra-ui/react';
import { useCustomBarLegend } from './useCustomBarLegend';
export function CustomBarLegends(param) {
    var data = param.data, answersById = param.answersById, layerData = param.layerData, _param_hiddenSeries = param.hiddenSeries, hiddenSeries = _param_hiddenSeries === void 0 ? [] : _param_hiddenSeries, _param_toggleSerie = param.toggleSerie, toggleSerie = _param_toggleSerie === void 0 ? function() {
    //
    } : _param_toggleSerie;
    var legendsData = useCustomBarLegend({
        data: data,
        layerData: layerData,
        hiddenSeries: hiddenSeries,
        answersById: answersById
    });
    return data ? /*#__PURE__*/ React.createElement(Stack, null, legendsData.map(function(legendData, index) {
        return /*#__PURE__*/ React.createElement(Flex, {
            key: "legend-".concat(index),
            alignItems: "center",
            w: "228px",
            cursor: "pointer",
            _hover: {
                fontWeight: 'bold'
            },
            onClick: function() {
                return toggleSerie(legendData.id);
            }
        }, /*#__PURE__*/ React.createElement(Square, {
            size: "6",
            borderRadius: "sm",
            bgColor: legendData.color
        }), /*#__PURE__*/ React.createElement(Text, {
            fontSize: "sm",
            ml: "2",
            textColor: legendData.textColor
        }, legendData.label));
    })) : null;
}
